import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=2c7e2e91&scoped=true"
var script = {}
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=2c7e2e91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7e2e91",
  null
  
)

export default component.exports